import { useField } from 'formik';
import { IdentityProvider } from 'generated/id-service-env-administration';
import React, { useMemo } from 'react';
import type { IdProviderFormData } from '../IdentityProviders.types';
import { ExternalProviders } from './Providers/ExternalProviders';
import { InternalProviders } from './Providers/InternalProviders';

export const ProviderField: React.FC = () => {
  const [internalField] = useField<
    IdProviderFormData['internalIdpConfiguration']
  >('internalIdpConfiguration');
  const [externalField, , externalHelpers] = useField<
    IdProviderFormData['externalIdpConfiguration']
  >('externalIdpConfiguration');

  const idpOptions = useMemo(() => {
    const currentIdps = externalField.value?.map((idp) => idp.idpId);

    currentIdps?.push(IdentityProvider.AxAuth);
    const idpOptions = Object.entries(IdentityProvider)
      .map(([key, value]) => {
        return {
          label:
            value === IdentityProvider.AzureAd
              ? 'Microsoft Entra ID (Azure AD)'
              : key,
          value: value,
        };
      })
      .filter((option) => !currentIdps?.includes(option.value));

    return idpOptions;
  }, [externalField.value]);

  return (
    <div style={{ display: 'grid' }}>
      <InternalProviders
        value={internalField.value}
        idpOptions={idpOptions}
        onAdd={(data) => {
          const sorted = externalField.value.sort(
            (a, b) => a.sortOrder - b.sortOrder,
          );

          data.sortOrder =
            sorted[sorted.length - 1]?.sortOrder === undefined
              ? 1
              : sorted[sorted.length - 1].sortOrder + 1;
          externalHelpers.setValue([...externalField.value, data]);
        }}
      />
      <ExternalProviders
        value={externalField.value}
        onChange={externalHelpers.setValue}
      />
    </div>
  );
};
